import Cart from "../../component/Cart/Cart";
import MCart from "../../component/mobile/cart/MCart";



const CART =()=>{
  return(
    <div className="CART">
      {window.innerWidth>1000 && <Cart/>}
      {window.innerWidth<1000 && <MCart/>}
    </div>
  )
}

export default CART;